export default __webpack_public_path__ + "static/media/ChromeIcon.c18cc955.png";